// AUTO-GENERATED by `pnpm --filter @borradh-workspace/contracts contracts:generate`.
// DO NOT EDIT — regenerate instead. Source: Drizzle table "asset".
// This file is pure Zod (no drizzle-zod / database in its runtime graph).
import { z } from 'zod';
import { assetSourceValues, assetTypeValues, footageActionValues, uploadFootageReviewStatusValues } from '@borradh-workspace/labels';
/** Response atom for the "asset" table (1:1 with a DB row, on the wire). */
export const assetAtomSchema = z.object({
    id: z.string(),
    name: z.string(),
    blobUrl: z.string(),
    thumbnailUrl: z.string().nullable(),
    sourceFileName: z.string().nullable(),
    tags: z.array(z.string()),
    clientName: z.string().nullable(),
    leadId: z.string().nullable(),
    type: z.enum(assetTypeValues),
    source: z.enum(assetSourceValues),
    placeholderTypes: z.array(z.string()),
    duration: z.number().nullable(),
    width: z.number().nullable(),
    height: z.number().nullable(),
    codec: z.string().nullable(),
    pixFmt: z.string().nullable(),
    bitrateKbps: z.number().nullable(),
    probeStatus: z.string(),
    probedAt: z.string().datetime().nullable(),
    transcodeStatus: z.string(),
    transcodedBlobUrl: z.string().nullable(),
    transcodedAt: z.string().datetime().nullable(),
    normalizedBlobUrl: z.string().nullable(),
    normalizedAt: z.string().datetime().nullable(),
    transcript: z.string().nullable(),
    capturedAt: z.string().datetime().nullable(),
    batchId: z.string().nullable(),
    stockClipId: z.string().nullable(),
    footageActions: z.array(z.enum(footageActionValues)),
    footageReviewStatus: z.enum(uploadFootageReviewStatusValues),
    footageReviewHistory: z.unknown(),
    organizationId: z.string(),
    uploadedById: z.string().nullable(),
    createdAt: z.string().datetime(),
    updatedAt: z.string().datetime(),
    deletedAt: z.string().datetime().nullable(),
});
//# sourceMappingURL=asset.js.map